/* eslint-disable prettier/prettier */

import { TagManagerArgs } from 'react-gtm-module';
import { TrackingEventsEnum } from 'types';

const host = window?.location?.hostname;
export const shouldTrack = host === 'hipaalink.net';

// Facebook Pixel ID
export const facebookPixelId = shouldTrack ? '1481118256204677' : '';

// Google Tag Manager
export const googleTagManagerInitializeArgs: TagManagerArgs = {
  gtmId: shouldTrack ? 'GTM-TB5H4F4' : '',
};

// Google Ads Event Mapping
export const googleEventIdMap: { [event in TrackingEventsEnum]: string } = {
  [TrackingEventsEnum.StartSignup]: shouldTrack ? 'AW-11158540419/IuhVCJDWy64YEIOh58gp' : '',
  [TrackingEventsEnum.CompleteRegistration]: shouldTrack ? 'AW-11158540419/PunLCOjqrJoYEIOh58gp' : '',
  [TrackingEventsEnum.InitiateCheckout]: shouldTrack ? 'AW-11158540419/qO-9COXqrJoYEIOh58gp' : '',
  [TrackingEventsEnum.CompleteCheckout]: shouldTrack ? 'AW-11158540419/OMULCJjDy64YEIOh58gp' : '',
  [TrackingEventsEnum.Recaptcha_Clicked]: shouldTrack ? 'AW-11158540419/nE2LCKfAsqkaEIOh58gp' : '',
  [TrackingEventsEnum.Recaptcha_Success]: shouldTrack ? 'AW-11158540419/LDIiCN2LoqkaEIOh58gp' : '',
  [TrackingEventsEnum.Recaptcha_Failed]: shouldTrack ? 'AW-11158540419/VNIVCI61tqkaEIOh58gp' : '',
};
